// Copyright (c) Move Closer 2022.

import { CartModel, CheckoutPayload } from '../contracts'
import { AnyObject } from '@movecloser/front-core'

/**
 * @author Agnieszka Zawadzka <agnieszka.zawadzka@movecloser.pl>
 */
export function translateCartToCheckoutPayload (cart: CartModel | null): Omit<CheckoutPayload, 'isSignupRequested' | 'isUserLoggedIn' | 'subscriptionAgreement' | 'acceptPrivacy'> | null {
  if (!cart?.isSet()) {
    return null
  }
  const billingAddress = cart.billingAddress
  const shippingAddress = cart.shippingAddress

  return {
    payment: {
      code: cart.selectedPaymentMethod!.code,
      ...cart.selectedPaymentMethod,
      methodId: cart.selectedPaymentMethodId ?? 0
    },
    shipping: cart.selectedShippingMethod,
    address: {
      address: shippingAddress?.street[0] || billingAddress?.street[0] || '',
      billingAddress: {
        address: billingAddress?.street[0] || '',
        city: billingAddress?.city || '',
        postalCode: billingAddress?.postcode || ''
      },
      city: shippingAddress?.city || billingAddress?.city || '',
      company: shippingAddress?.company || '',
      country: shippingAddress?.countryCode || billingAddress?.countryCode || 'PL',
      phone: shippingAddress?.telephone || billingAddress?.telephone || '',
      postalCode: shippingAddress?.postcode || billingAddress?.postcode || '',
      invoice: {
        nip: billingAddress?.vatId || '',
        company: billingAddress?.company || ''
      }
    },
    user: {
      email: cart.email || '',
      firstName: shippingAddress?.firstname || billingAddress?.firstname || null,
      lastName: shippingAddress?.lastname || billingAddress?.lastname || null,
      phone: shippingAddress?.telephone || '',
      password: '',
      passwordConfirmation: ''
    },
    note: cart.note || '',
    sameBillingAddress: shippingAddress === null || cart.isSameBillingAddress(),
    hasInvoice: cart.hasInvoice()
  }
}

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export function translateCheckoutPayloadToValidationObject (payload: CheckoutPayload): AnyObject {
  return {
    address: payload.address.address,
    billingAddress: payload.address.billingAddress.address,
    billingCity: payload.address.billingAddress.city,
    billingPostalCode: payload.address.billingAddress.postalCode,
    city: payload.address.city,
    company: payload.address.company,
    country: payload.address.country,
    email: payload.user.email,
    firstName: payload.user.firstName,
    hasInvoice: payload.hasInvoice,
    invoiceCompany: payload.address.invoice?.company,
    invoiceNip: payload.address.invoice?.nip,
    isSignupRequested: payload.isSignupRequested,
    lastName: payload.user.lastName,
    password: payload.user.password,
    passwordConfirmation: payload.user.passwordConfirmation,
    payment: payload.payment,
    phone: payload.address.phone,
    postalCode: payload.address.postalCode,
    sameBillingAddress: payload.sameBillingAddress,
    shipping: payload.shipping
  }
}
